
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  open: true,
}

export const expanderSlice = createSlice({
  name: 'sideExpand',
  initialState,
  reducers: {
    trigger: (state) => {
        state.open = !state.open
    },
    closeExpand: (state) =>{
      state.open = false
    },
    openExpand: (state) =>{
      state.open = true
    },
  },
})

// Action creators are generated for each case reducer function
export const { trigger, closeExpand, openExpand } = expanderSlice.actions

export default expanderSlice.reducer